import React, { Component } from 'react';
import isSupported from 'mapbox-gl-supported';
import BostonMapbox from './marathon/BostonMapbox.jsx';
import NoGlMap from './fallback/NoGlMap.jsx';
import './attribution.css';

import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import injectTapEventPlugin from 'react-tap-event-plugin';
injectTapEventPlugin();

// This replaces the textColor value on the palette
// and then update the keys for each component that depends on it.
// More on Colors: http://www.material-ui.com/#/customization/colors
const muiTheme = getMuiTheme({
  textField: {
    focusColor: "#888",
  },
  flatButton: {
    primaryTextColor: "#000",
    textColor: "#333",
  },
});

class App extends Component {
  render() {
    const GlSupported = isSupported();
    return (
      <MuiThemeProvider muiTheme={muiTheme}>
        <div>
          <div className="rovemap-attrib">
            © <a href="https://www.rovemap.com" target="_blank">Rovemap</a>
          </div>
          {GlSupported
            ? <div id="map" />
            : <div id="no-gl-map" />}
          {GlSupported
            ? <BostonMapbox />
            : <NoGlMap />}
        </div>
      </MuiThemeProvider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js